import { EProviderType, IFinanceQuote } from "src/services/calculateSummary/calculateSummary.types";

export const isFinanceQuoteLeasys = (financeQuote: IFinanceQuote) => {
    return financeQuote && financeQuote.providerType === EProviderType.LEASYS && !!financeQuote.token && !!financeQuote.quotationId;
};